import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { LogService } from 'src/app/services/log.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../models/Constants';
import { LogoutBusinessLogicService } from 'src/app/services/logout-business-logic.service';
import { ApiService } from 'src/app/services/api.service';
import { TbaBusinessLogicService } from 'src/app/services/tba-business-logic.service';
import { environment } from 'src/environments/environment';
import buildInfo from 'src/build';



@Component({
  selector: 'app-user-profile-data-card',
  templateUrl: './user-profile-data-card.component.html',
  styleUrls: ['./user-profile-data-card.component.scss'],
})
export class UserProfileDataCardComponent implements OnInit {
  iconConfig: any;
  isDisplay = false;
  isShown: boolean = false;
  finalShowProfileCardVal: boolean = false;
  items: { name: string; selected: boolean; id: string }[];
  showAngularVersion: any = "";
  showTimeStamp: any = "";
  showFullHash: any = "";
  simulatorOn:boolean = false;
  simulatorOff:boolean = false;

  constructor(
    public dialog: MatDialog,

    public rootScope: RootScopeService,
    private elementRef: ElementRef,
    private apiService: ApiService,
    private logOutService: LogoutBusinessLogicService,
    private genesysCloudService :GenesysCloudService
  ) {
    this.items = this.rootScope.items;

    this.iconConfig = {
      iconName: 'times',
      iconType: 'fal',
    };
    this.showAngularVersion = environment.version
    this.showTimeStamp = buildInfo.timestamp
    this.showFullHash = buildInfo.git.fullHash

  }

  ngOnInit(): void { }

  /**
   * Below method is called when user tries to
   * open user profile data card
   */
  showDataCard() {
    this.finalShowProfileCardVal = true;
  }

  closeDataCard() {
    this.finalShowProfileCardVal = false;
  }

  /**
   * Below method is called when
   * user click on logout button
   */
  userLogout() {
    // console.log(this.rootScope.customerTabs.length);
    this.logOutService.validateLogOut(this);
    // if (this.rootScope.customerTabs.length > 1) {
    //   if (localStorage.getItem('isLiveCall') == 'true') {
    //     this.rootScope.openDialog({
    //       title: '',
    //       subheading:'',
    //       message: Constants.user_logout_MSGACTIVECALL,
    //       firstbutton: '',
    //       secondbutton: Constants.buttonEnum.gotIt,
    //       crossIcon: false,
    //       comingFrom: 'userprofile',
    //       additionalClass: 'logout-modal',
    //     });
    //   }
    //   else if (localStorage.getItem('isLiveChat') == 'true') {
    //     this.rootScope.openDialog({
    //       title: '',
    //       subheading:'',
    //       message: Constants.user_logout_MSGACTIVECHATS,
    //       firstbutton: '',
    //       secondbutton: Constants.buttonEnum.gotIt,
    //       crossIcon: false,
    //       comingFrom: 'userprofile',
    //       additionalClass: 'logout-modal',
    //     });
    //   }
    //   else {
    //     this.rootScope.openDialog({
    //       title: '',
    //       subheading:'',
    //       message: Constants.user_logout_MSGOPENACCOUNT,
    //       firstbutton: '',
    //       secondbutton: Constants.buttonEnum.gotIt,
    //       crossIcon: false,
    //       comingFrom: 'userprofile',
    //       additionalClass: 'logout-modal',
    //     });
    //   }
    // }
    // else { this.rootScope.closeAllKcWindow();
    //   let linkMessageString = this.rootScope.linkTrackingMap?.get(Constants.DASHBOARD_LINK_TRACKING);
    //   if(linkMessageString){
    //     this.rootScope.linkTrackingMap?.delete(Constants.DASHBOARD_LINK_TRACKING);
    //     let logObj = this.rootScope.createAngluarLogsObject(linkMessageString,'usage','N/A');
    //     this.genesysCloudService.awsSQSService.sendAngularLogsToSQS(logObj);
    //   }

    //   this.apiService.userLogout();
    //   this.tbaService.closeTbaLogout();



    // }
  }


  // ShowPopup() {
  //   this.rootScope.openDialog({
  //     title: '',
  //     message: Constants.user_logout_MSG,
  //     firstbutton: '',
  //     secondbutton: Constants.buttonEnum.gotIt,
  //     crossIcon: false,
  //     comingFrom: 'userprofile',
  //     additionalClass: 'logout-modal',
  //   });
  // }
/* istanbul ignore next */
  startSimulator() {
    this.rootScope.openDialog({
      title: 'Starting a simulation?',
      subheading: '',
      message: "Simulation Mode is for training and testing purposes. Registration with ALIS is not supported while in Simulation Mode.",
      firstbutton: 'Cancel',
      secondbutton:'Continue',
      crossIcon: false,
      comingFrom: 'userprofile',
      additionalClass: 'start-simulator',
    });
  }
  /* istanbul ignore next */
  exitSimulator() {
    this.rootScope.openDialog({
      title: 'Exit Simulation Mode?',
      subheading: '',
      message: "All simulations will end and the customer accounts will close.",
      firstbutton: 'Cancel',
      secondbutton:'Exit',
      crossIcon: false,
      comingFrom: 'userprofile',
      additionalClass: 'exit-simulator',
    });
  }

  /* istanbul ignore next */
  onToggleChange(event: any) {    
    if (event.checked) {
      console.log("start the simulator ");
      this.startSimulator();
    }   
  }
  
  openHelpPdf() {
    let helpUrl = this.rootScope.getObjFromConfigObj(Constants.USER_PROFILE_HELP_URL)?.['fieldValue'];
    this.rootScope.openNewTab(helpUrl);
  }
  openPrivacyLink() {
    this.rootScope.openNewTab(Constants.PRIVACY_URL);
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    // console.log('event ', event.target);
    // console.log(
    //   'target',
    //   this.elementRef.nativeElement.contains(event.target as HTMLElement)
    // );
    const targetElement = event.target as HTMLElement;
    if (
      targetElement &&
      !this.elementRef.nativeElement.contains(targetElement)
    ) {
      this.finalShowProfileCardVal = false;
    }
  }
}
